import type { ThemeState } from '@atlaskit/tokens/theme-config';

export type ThemeChangeHandler = (theme: Partial<ThemeState>) => void;

export class WhiteboardThemingService {
	private handlers: Set<ThemeChangeHandler> = new Set();
	private theme: Partial<ThemeState> | undefined = undefined;

	dispose(): void {
		this.handlers.clear();
	}

	updateTheme(theme: Partial<ThemeState>): void {
		this.theme = theme;
		this.handlers.forEach((handler) => handler(theme));
	}

	onThemeChange(cb: ThemeChangeHandler): () => void {
		this.handlers.add(cb);

		return () => {
			this.handlers.delete(cb);
		};
	}

	getTheme(): Partial<ThemeState> | undefined {
		return this.theme;
	}
}

export const whiteboardThemingService: WhiteboardThemingService = new WhiteboardThemingService();
